import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getScrubMetadata,postScrubMetadata,downloadScrubExcel } from '../../redux/actions/b2b_action';
import Loader from '../loader/loader';
import { 
    faSearch, faBookmark, faFilter, faTimes, 
    faUser, faChevronDown, faChevronUp, faSave, 
    faFileExcel, faTrashAlt, faSort
} from '@fortawesome/free-solid-svg-icons';

// const initialCustomers = [
//     {
//         id: 1,
//         name: 'MANASI NAYAK',
//         date: '30-01-2024',
//         expanded: true,
//         performConsumer: 765,
//         xSellScore: 1433,
//         accountType: 'Loan',
//         accountStatus: 'Active',
//         accountLastPaymentDate: '2024-01-15',
//         summary: {
//             edsApplicationId: '556054551',
//             creditReportId: 'RAJA1507Z0CR113712898',
//             phoneNumber: '+91 9199760183',
//             activeAccounts: 10,
//             gender: 'Female',
//             overdueAccounts: 2,
//             pan: 'AUJPN1458K',
//             newAccounts: 1
//         }
//     },
//     {
//         id: 2,
//         name: 'ADITYA SHARMA',
//         date: '30-01-2024',
//         expanded: false,
//         performConsumer: 720,
//         xSellScore: 1290,
//         accountType: 'Credit Card',
//         accountStatus: 'Active',
//         accountLastPaymentDate: '2024-01-10',
//     },
//     {
//         id: 3,
//         name: 'RIZWAN SHEHZAD',
//         date: '30-01-2024',
//         expanded: false,
//         performConsumer: 680,
//         xSellScore: 1120,
//         accountType: 'Mortgage',
//         accountStatus: 'Overdue',
//         accountLastPaymentDate: '2023-12-20',
//     },
//     {
//         id: 4,
//         name: 'JOSEPH STALLONE',
//         date: '30-01-2024',
//         expanded: false,
//         performConsumer: 810,
//         xSellScore: 1560,
//         accountType: 'Personal Loan',
//         accountStatus: 'Active',
//         accountLastPaymentDate: '2024-01-25',
//     },
//     {
//         id: 5,
//         name: 'SRAVANTHI DONAKONDA',
//         date: '30-01-2024',
//         expanded: false,
//         performConsumer: 790,
//         xSellScore: 1480,
//         accountType: 'Auto Loan',
//         accountStatus: 'Closed',
//         accountLastPaymentDate: '2023-11-30',
//     }
// ];



const AdvanceSearch = (props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [activeFilters, setActiveFilters] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showSavedSearches, setShowSavedSearches] = useState(false);
    const [savedSearches, setSavedSearches] = useState([]);
    const [customers, setCustomers] = useState();
    const [filteredCustomers, setFilteredCustomers] = useState();
    const [suggestionType, setSuggestionType] = useState('attributes');
    const [dynamicSearchConfig, setDynamicSearchConfig] = useState([]);
    const [selectedAttribute, setSelectedAttribute] = useState(null);
    const [apiJson, getapiJsonData] = useState({});
    const [loader, setLoader] = useState(false);
    const [scrubDataQuery,setScrubDataQuery] = useState('');
    const [searchedData,setSearchedData] = useState(false);

    // Example JSON from API
// const apiJson = {
//     "operators": {
//         "EQUAL": {
//             "sign": "=",
//             "type_supported": [
//                 "STRING",
//                 "NUMBER",
//                 "DATE",
//                 "BOOLEAN"
//             ]
//         },
//         "GREATER_THAN": {
//             "sign": ">",
//             "type_supported": [
//                 "NUMBER",
//                 "DATE"
//             ]
//         },
//         "NOT_EQUAL": {
//             "sign": "!=",
//             "type_supported": [
//                 "STRING",
//                 "NUMBER",
//                 "DATE",
//                 "BOOLEAN"
//             ]
//         },
//         "LESS_THAN_OR_EQUAL_TO": {
//             "sign": "<=",
//             "type_supported": [
//                 "NUMBER"
//             ]
//         },
//         "CONTAINS": {
//             "sign": "contains",
//             "type_supported": [
//                 "STRING"
//             ]
//         },
//         "LESS_THAN": {
//             "sign": "<",
//             "type_supported": [
//                 "NUMBER",
//                 "DATE"
//             ]
//         },
//         "GREATER_THAN_OR_EQUAL_TO": {
//             "sign": ">=",
//             "type_supported": [
//                 "NUMBER"
//             ]
//         }
//     },
//     "attributes": [
//         {
//             "name": "Score (X Sell Score)",
//             "type": "NUMBER"
//         },
//         {
//             "name": "Score (Perform Consumer 2.0)",
//             "type": "NUMBER"
//         },
//         {
//             "name": "Gender",
//             "type": "STRING"
//         },
//         {
//             "name": "AccountType",
//             "type": "STRING"
//         }
//     ]
// };

    // Function to dynamically generate searchConfig from JSON
    const generateSearchConfig = (jsonConfig) => {
        // Transform operators from object to array format
        const operators = Object.entries(jsonConfig.operators).map(([id, details]) => ({
            id,
            symbol: details.sign,
            label: id.split('_').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join(' '),
            applicable: details.type_supported
        }));

        // Transform attributes to the required format
        const attributes = jsonConfig.attributes.map(attr => ({
            id: attr.name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase(),
            label: attr.name,
            type: attr.type
        }));

        return {
            attributes,
            operators
        };
    };

    // // Log the selected attribute for debugging
    // useEffect(() => {
    //     if (selectedAttribute) {
    //         console.log('Selected attribute:', selectedAttribute);
    //         console.log('Applicable operators:', getApplicableOperators());
    //     }
    // }, [selectedAttribute]);

     useEffect(() => {
        getScrubMetadata().then((resp) => {
            getapiJsonData(resp);
            const searchConfig = generateSearchConfig(resp);
            setDynamicSearchConfig(searchConfig);
         }).catch((error)=>{
            console.log(error)
         })
    }, []);


    // Function to parse search query and generate request payload
const parseSearchQuery = (query) => {
    // Updated regex to better handle conditions with parentheses
    // This pattern uses a positive lookahead to ensure we don't split inside parentheses
    const regex = /(@(?:[^()@]|\([^)]*\))+?)(?:\s+(and|or)\s+|$)/gi;
    let match;
    const parts = [];
    let lastIndex = 0;
    
    while ((match = regex.exec(query)) !== null) {
        const condition = match[1].trim();
        const operator = match[2] ? match[2].toLowerCase() : null;
        parts.push({ condition, operator });
        lastIndex = regex.lastIndex;
    }
    
    // If we didn't parse the entire string, there might be an issue
    if (lastIndex < query.length) {
        console.warn('Could not fully parse the query:', query);
    }

    // Parse each condition into attribute, operator, and value
    const parsedConditions = parts.map(part => {
        // Create a regex pattern that includes all operator signs from apiJson
        const operatorSigns = Object.values(apiJson.operators)
            .map(op => op.sign.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
            .sort((a, b) => b.length - a.length)
            .join('|');
            
        // Updated regex to better handle attribute names with parentheses
        const conditionRegex = new RegExp(`@([^=><!\n]+?(?:\\([^)]*\\))?[^=><!\n]*?)\\s*(${operatorSigns})\\s*(.+)`, 'i');
        const conditionMatch = part.condition.match(conditionRegex);
        
        if (conditionMatch) {
            const [, attributeRaw, operatorSymbol, valueRaw] = conditionMatch;
            const attribute = attributeRaw.trim();
            const value = valueRaw.trim();
            
            // Generate operatorMap dynamically from apiJson
            const operatorMap = Object.entries(apiJson.operators).reduce((map, [key, details]) => {
                map[details.sign] = key;
                return map;
            }, {});
            
            // Find the operator key from the symbol
            const operatorKey = operatorMap[operatorSymbol] || "";
            
            return {
                condition: {
                    attribute: attribute,
                    operator: operatorKey,
                    value: value
                },
                operator: part.operator ? part.operator.toUpperCase() : null
            };
        }
        
        return null;
    }).filter(Boolean);
    
    // Build the payload with right-to-left evaluation for the specific example structure
    const buildPayloadStructure = (conditions) => {
        if (conditions.length === 0) {
            return {
                logicalOperator: "AND",
                conditions: []
            };
        }
        
        if (conditions.length === 1) {
            return {
                logicalOperator: "AND",
                conditions: [conditions[0].condition]
            };
        }
        
        // For the specific example structure:
        // - First condition is standalone
        // - The rest are nested with right-to-left evaluation
        
        // Get the first condition (clientId = 4556889)
        const firstCondition = conditions[0].condition;
        
        // Process the remaining conditions from right to left
        const remainingConditions = conditions.slice(1);
        
        // Start with the last two conditions
        if (remainingConditions.length >= 2) {
            const lastCondition = remainingConditions[remainingConditions.length - 1];
            const secondLastCondition = remainingConditions[remainingConditions.length - 2];
            
            // Create the innermost group (OR group from the example)
            let nestedGroup = {
                logicalOperator: secondLastCondition.operator || "AND",
                conditions: [secondLastCondition.condition, lastCondition.condition]
            };
            
            // Process remaining conditions from right to left
            for (let i = remainingConditions.length - 3; i >= 0; i--) {
                const currentCondition = remainingConditions[i];
                
                // Create a new group with the current condition and the previous nested group
                nestedGroup = {
                    logicalOperator: currentCondition.operator || "AND",
                    conditions: [
                        currentCondition.condition,
                        nestedGroup
                    ]
                };
            }
            
            // Return the final structure with the first condition and the nested group
            return {
                logicalOperator: conditions[0].operator || "AND",
                conditions: [
                    firstCondition,
                    nestedGroup
                ]
            };
        } else {
            // If only one remaining condition, create a simple structure
            return {
                logicalOperator: conditions[0].operator || "AND",
                conditions: [
                    firstCondition,
                    remainingConditions[0].condition
                ]
            };
        }
    };
    
    // Initialize the payload structure
    const payload = {
        filters: buildPayloadStructure(parsedConditions),
        pagination: {
            page: 0,
            size: 20
            // orders: "requestDate;DESC"
        }
    };
    
    return payload;
};

    // Function to extract the current attribute from the query
    const extractCurrentAttribute = () => {
        const parts = searchQuery.split(' ');
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].startsWith('@')) {
                const attrName = parts[i].substring(1);
                const attribute = dynamicSearchConfig.attributes.find(attr => 
                    attr.label.toLowerCase() === attrName.toLowerCase());
                
                if (attribute) {
                    return attribute;
                }
            }
        }
        return null;
    };

    // Get applicable operators for the selected attribute
    const getApplicableOperators = () => {
        // Use the stored selected attribute or try to extract it from the query
        const attribute = selectedAttribute || extractCurrentAttribute();
        
        if (!attribute) {
            return [];
        }
        
        // Filter operators based on the attribute type
        const applicableOperators = dynamicSearchConfig.operators.filter(op => 
            op.applicable.includes(attribute.type));
        
        console.log(`Filtered operators for ${attribute.label} (${attribute.type}):`, 
            applicableOperators.map(op => op.symbol));
        
        return applicableOperators;
    };

    const handleSearchInputChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        
        // Parse the query to determine what suggestions to show
        const parts = value.split(' ');
        const lastPart = parts[parts.length - 1];
        
        if (lastPart.startsWith('@')) {
            // If typing right after @, suggest attributes
            setShowSuggestions(true);
            setSuggestionType('attributes');
            setSelectedAttribute(null); // Reset selected attribute
        } else if (value.includes('@')) {
            // Check if we have a valid attribute
            const currentAttribute = extractCurrentAttribute();
            
            if (currentAttribute) {
                // Store the selected attribute
                setSelectedAttribute(currentAttribute);
                
                // Check if we need to suggest operators
                const operatorIndex = parts.findIndex((part, index) => 
                    index > 0 && parts[index - 1].startsWith('@'));
                
                if (operatorIndex === parts.length - 1 || operatorIndex === -1) {
                    // We're right after an attribute, suggest operators
                    setShowSuggestions(true);
                setSuggestionType('operators');
                } else {
                    // Check if we have a complete condition
                    const hasOperator = dynamicSearchConfig.operators.some(op => 
                        parts.includes(op.symbol));
                    
                    if (hasOperator && value.endsWith(' ') && 
                        !['and', 'or'].includes(parts[parts.length - 1])) {
                        // Show logical operators after a complete condition
                        setShowSuggestions(true);
                        setSuggestionType('logical');
                    } else {
                        setShowSuggestions(false);
                    }
                }
            } else {
                setShowSuggestions(false);
            }
        } else {
            // No @ symbol, don't show suggestions
            setShowSuggestions(false);
            setSelectedAttribute(null);
        }
    };

    const handleSuggestionClick = (suggestion, type) => {
        let newQuery = searchQuery;
        
        if (type === 'attributes') {
            // Keep @ and append the attribute
            if (newQuery.includes('@')) {
                const atIndex = newQuery.lastIndexOf('@');
                newQuery = newQuery.substring(0, atIndex + 1) + suggestion.label + ' ';
            } else {
                newQuery = '@' + suggestion.label + ' ';
            }
            
            // Store the selected attribute
            setSelectedAttribute(suggestion);
            setSuggestionType('operators');
        } else if (type === 'operators') {
            // Append the operator
            newQuery = newQuery.trim() + ' ' + suggestion.symbol + ' ';
            // Don't suggest values, let user type them
            setShowSuggestions(false);
        } else if (type === 'logical') {
            // Append logical operator and prepare for next attribute
            newQuery = newQuery.trim() + ' ' + suggestion + ' @';
            setSelectedAttribute(null);
            setSuggestionType('attributes');
        }
        
        setSearchQuery(newQuery);
    };

    // Get suggestions based on the current context
    const getSuggestions = () => {
        if (!showSuggestions) return [];
        
        if (suggestionType === 'attributes') {
            // Filter attributes by what's typed after @
        if (searchQuery.includes('@')) {
                const lastAtIndex = searchQuery.lastIndexOf('@');
                const query = searchQuery.substring(lastAtIndex + 1).toLowerCase();
                return dynamicSearchConfig.attributes.filter(attr => 
                attr.label.toLowerCase().includes(query));
            } else {
                // Show all attributes
                return dynamicSearchConfig.attributes;
            }
        } else if (suggestionType === 'operators') {
            // Get operators applicable to the selected attribute
            return getApplicableOperators();
        } else if (suggestionType === 'logical') {
            return ['and', 'or'];
        }
        
        return [];
    };

    // Add the handleSearch function
    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            try {
                // Parse the search query and generate request payload
                const requestPayload = parseSearchQuery(searchQuery);
                setScrubDataQuery(requestPayload)    

                // Log the payload to the console
                //console.log('Search Request Payload:');
                //console.log(JSON.stringify(requestPayload, null, 2));
                
                // Here you would typically make an API call with the payload
                // For example:
                setLoader(true)
                postScrubMetadata(requestPayload).then(data => {
                
                    setSearchedData(data?.scrubMetaDataEntityList.length > 0 ? true : false)
                    props.setUserListData(data?.scrubMetaDataEntityList)
                    props.setUserListDataFilter(data?.scrubMetaDataEntityList)
                    props.setTotalRecordFromApi(data?.totalData)
                    props.setTotalPageFromApi(data?.totalPage)
                    setLoader(false)
                    //setFilteredCustomers(data);
                }).catch((error)=>{
                     setLoader(false)
                    console.log("Error Posting ScrubData" + error)
                });
                
                // Add the search query to active filters
                setActiveFilters([...activeFilters, searchQuery]);
                setSearchQuery('');
                setShowSuggestions(false);
                setSelectedAttribute(null);
            } catch (error) {
                console.error('Error parsing search query:', error);
            }
        }
    };

    // Function to remove a filter
    const removeFilter = (index) => {
        const newFilters = [...activeFilters];
        newFilters.splice(index, 1);
        setActiveFilters(newFilters);
        props.getCustomerListFun();
       // props.setUserListData('');
       // props.setUserListDataFilter('');
       
    };

    const downloadExcel = () => {
      setLoader(true);
      downloadScrubExcel(scrubDataQuery)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response], { type: "application/excel" }));
          const a = document.createElement('a');
          a.href = url;
          a.download = 'ScrubDataReport.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          setLoader(false);
        })
        .catch(error => {
          setLoader(false);
          console.error('Error downloading the Excel file:', error);
        });
    };

    return (
        
        <div className="col-12">
            {loader && <Loader />}
            {/* Main Content */}
            {/* Natural Language Search Widget */}
            <div className="mb-4">
                <form onSubmit={handleSearch} className="position-relative">
                    <div className="position-relative">
                        <div className="d-flex align-items-center border rounded overflow-hidden">
                            <div className="ps-3 pe-2 text-muted">
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                className="form-control border-0 py-2 px-2"
                                placeholder="Type @ to see all attributes (e.g., '@Score (Perform Consumer 2.0) > 750')"
                            />

                            <button
                                type="submit"
                                className="btn btn-primary px-3 py-2"
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>

                        {/* Saved Searches Dropdown */}
                        {showSavedSearches && (
                            <div className="position-absolute end-0 mt-2 bg-white border rounded shadow-lg z-3" style={{ width: '320px' }}>
                                <div className="p-3">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h3 className="small fw-semibold text-secondary">Saved Searches</h3>
                                        <span className="text-muted small">{savedSearches.length} saved</span>
                                    </div>
                                    {savedSearches.length === 0 ? (
                                        <div className="text-center py-4">
                                            <div className="text-muted mb-2">
                                                <FontAwesomeIcon icon={faSearch} className="fs-3" />
                                            </div>
                                            <p className="text-secondary small">No saved searches yet</p>
                                            <p className="text-muted smaller mt-1">Your saved searches will appear here</p>
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-column gap-1">
                                            {savedSearches.map((search, index) => (
                                                <div
                                                    key={index}
                                                    className="px-3 py-2 hover-bg-light rounded d-flex align-items-center justify-content-between cursor-pointer"
                                                >
                                                    <div className="d-flex align-items-center flex-grow-1 min-width-0">
                                                        <FontAwesomeIcon icon={faSearch} className="text-muted me-3" />
                                                        <span
                                                            className="small text-secondary text-truncate"
                                                            onClick={() => {
                                                                setActiveFilters(search.filters);
                                                                setShowSavedSearches(false);
                                                            }}
                                                        >
                                                            {search.name}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex align-items-center ms-2">
                                                        <button
                                                            onClick={() => {
                                                                setActiveFilters(search.filters);
                                                                setShowSavedSearches(false);
                                                            }}
                                                            className="btn btn-sm text-primary me-3 btn-hover-show"
                                                        >
                                                            Use
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const newSearches = savedSearches.filter((_, i) => i !== index);
                                                                setSavedSearches(newSearches);
                                                            }}
                                                            className="btn btn-sm text-muted hover-text-danger btn-hover-show"
                                                        >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Suggestions Dropdown */}
                    {showSuggestions && (
                        <div className="position-absolute w-100 mt-1 bg-white border rounded shadow-lg z-3 show-on-table">
                            {suggestionType === 'attributes' && (
                                <div className="p-2">
                                    <h3 className="small fw-semibold text-muted mb-1">ATTRIBUTES</h3>
                                    {getSuggestions().map((attr, index) => (
                                        <div
                                            key={index}
                                            className="px-3 py-1 hover-bg-light rounded cursor-pointer small"
                                            onClick={() => handleSuggestionClick(attr, 'attributes')}
                                        >
                                            {attr.label} ({attr.type})
                                        </div>
                                    ))}
                                </div>
                            )}
                            
                            {suggestionType === 'operators' && (
                                <div className="p-2">
                                    <h3 className="small fw-semibold text-muted mb-1">
                                        OPERATORS FOR {selectedAttribute?.label} ({selectedAttribute?.type})
                                    </h3>
                                    {getSuggestions().length > 0 ? (
                                        getSuggestions().map((op, index) => (
                                        <div
                                            key={index}
                                            className="px-3 py-1 hover-bg-light rounded cursor-pointer small"
                                            onClick={() => handleSuggestionClick(op, 'operators')}
                                        >
                                            {op.symbol} - {op.label}
                                        </div>
                                        ))
                                    ) : (
                                        <div className="px-3 py-2 text-muted">
                                            No applicable operators for this attribute type
                                        </div>
                                    )}
                                </div>
                            )}
                            
                            {suggestionType === 'logical' && (
                                <div className="p-2">
                                    <h3 className="small fw-semibold text-muted mb-1">LOGICAL OPERATORS</h3>
                                    {getSuggestions().map((op, index) => (
                                        <div
                                            key={index}
                                            className="px-3 py-1 hover-bg-light rounded cursor-pointer small"
                                            onClick={() => handleSuggestionClick(op, 'logical')}
                                        >
                                            {op}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </form>

                {/* Active Filters */}
                {activeFilters.length > 0 && (
                    <div className="mt-3 d-flex flex-wrap gap-2">
                        {activeFilters.map((filter, index) => (
                            <div key={index} className="d-flex align-items-center bg-primary bg-opacity-10 text-primary px-3 py-1 rounded-pill small">
                                <span>{filter}</span>
                                <button
                                    onClick={() => removeFilter(index)}
                                    className="btn btn-sm ms-2 p-0 text-primary"
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                            </div>
                        ))}
                        {/* <button
                            onClick={() => clearFilter()}
                            className="btn btn-sm text-secondary ms-2"
                        >
                            Clear all
                        </button> */}
                       {searchedData &&
                        <button
                             onClick={() => downloadExcel()}
                            className="btn btn-sm text-primary ms-2 d-flex align-items-center"
                        >
                            <FontAwesomeIcon icon={faFileExcel} className="me-1" /> Export Report
                        </button>}
                    </div>
                )}



            </div>
            
            {/* <div className="d-flex flex-grow-1">
                <div className="flex-grow-1 p-4">
                    <h1 className="fs-3 fw-semibold mb-4">My Customers</h1>
                    <div className="bg-white rounded shadow-sm border p-4">
                        <h2 className="fs-5 fw-medium mb-4">Customers List</h2>
                        
                        
                    </div>
                </div>
            </div> */}

            {/* Add custom CSS for hover effects */}
            <style dangerouslySetInnerHTML={{
                __html: `
                .hover-bg-primary-dark:hover {
                    background-color: rgba(0, 0, 0, 0.1);
                }
                .hover-bg-light:hover {
                    background-color: #f8f9fa;
                }
                .hover-text-white:hover {
                    color: white !important;
                }
                .hover-text-danger:hover {
                    color: #dc3545 !important;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
                .btn-hover-show {
                    opacity: 0;
                }
                *:hover > .btn-hover-show {
                    opacity: 1;
                }
                .bg-primary-dark {
                    background-color: rgba(0, 0, 0, 0.15);
                }
                .min-width-0 {
                    min-width: 0;
                }
                .text-truncate {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .smaller {
                    font-size: 0.75rem;
                }
                .show-on-table{
                    z-index: 10;
                    background: white;
                    position: relative;
                    text-align: left;
                    border: 1px solid #CECECE;
                    border-radius: 5px;
                }
                `
            }} />
        </div>
    );
}

export default AdvanceSearch;




